// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".online-chat-root .input-items input[data-v-3c9cc9bc]{margin-right:.5em!important}", "",{"version":3,"sources":["webpack://./chat/vue/widget/form/fields/ChatRadioInput.vue"],"names":[],"mappings":"AACA,sDACI,2BAAA","sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
